var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"top":"","right":"","color":_vm.$store.getters.snackbar.color,"timeout":500},model:{value:(_vm.$store.getters.snackbar.value),callback:function ($$v) {_vm.$set(_vm.$store.getters.snackbar, "value", $$v)},expression:"$store.getters.snackbar.value"}},[_vm._v(" "+_vm._s(_vm.$store.getters.snackbar.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }